module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/051-cayman-islands-6c96cc3076e7e182ee82aa25e940887f.svg";